import React from "react";
import Header from "../../../layouts/AuthLayout/header/header";
import SampleProductsSection from "./sample-products-section";

export default function SampleProductsPage() {
  return (
    <>
      <Header />
      <SampleProductsSection />
    </>
  );
}
